import { render, staticRenderFns } from "./ErrorScreen.component.vue?vue&type=template&id=93eba4f2&scoped=true"
import script from "./ErrorScreen.component.vue?vue&type=script&lang=js"
export * from "./ErrorScreen.component.vue?vue&type=script&lang=js"
import style0 from "./ErrorScreen.component.vue?vue&type=style&index=0&id=93eba4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93eba4f2",
  null
  
)

export default component.exports